module.exports = __webpack_public_path__ + "static/media/picture.1a3294de.svg";